package app.nestbridge.app.usecase

import app.nestbridge.app.context.identity.UserContext
import app.nestbridge.app.context.identity.UserContextProvider
import kotlinx.coroutines.flow.StateFlow
import me.tatarka.inject.annotations.Inject

@Inject
class GetUserContextUseCase(
    private val userContextProvider: UserContextProvider,
) {
    suspend operator fun invoke(): StateFlow<UserContext?> = userContextProvider.context
}
